import { EmailFormBase } from '@bases/email-form/email-form.base';
import { Email } from '@models/email';
import { EmailAttachment } from '@models/email-attachment';

export class EmailForm extends EmailFormBase {
  toEmail(): Email {
    const email = new Email(
      this.from.value,
      this.to.value.map(emailAddressForm => emailAddressForm.address),
      this.cc.value.map(emailAddressForm => emailAddressForm.address),
      this.cci.value.map(emailAddressForm => emailAddressForm.address),
      this.subject.value,
      this.body.value
    );

    if (this.attachments.controls.length > 0) {
      const attachments: EmailAttachment[] = [];
      this.attachments.controls.forEach(emailAttachementForm => {
        const attachment = new EmailAttachment(
          null,
          emailAttachementForm.type.value,
          emailAttachementForm.name.value,
          emailAttachementForm.content.value
        );
        attachments.push(attachment);
      });
      email.attachments = attachments;
    }

    if (this.controls.replyTo.value) {
      email.replyTo = this.controls.replyTo.value;
    }

    return email;
  }
}
